import { useState } from "react";
import {
  ResponseGetRemarksTemplateResponse,
  RequestGetRemarksTemplateRequest,
  RemarksTemplateApi,
  RemarksTemplateGetAllRemarksTemplatePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetAllRemarksTemplate = () => {
  const [remarksTemplateList, setRemarksTemplateList] = useState<
    ResponseGetRemarksTemplateResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchRemarksTemplateList = async (
    requestParams: RequestGetRemarksTemplateRequest,
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: RemarksTemplateGetAllRemarksTemplatePostRequest = {
        req: requestParams,
      };

      const api = new RemarksTemplateApi(config);
      const response =
        await api.remarksTemplateGetAllRemarksTemplatePost(request);
      setRemarksTemplateList(response);
      return response;
    } catch (err) {
      setError("備考一覧の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { remarksTemplateList, fetchRemarksTemplateList, error, isLoading };
};
